import { render, staticRenderFns } from "./PartnerSettingsForm.vue?vue&type=template&id=0b8e9e18&"
import script from "./PartnerSettingsForm.vue?vue&type=script&lang=js&"
export * from "./PartnerSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports